import createMultiple from "./create-multiple.js";
import deleteMultiple from "./delete-multiple.js";
import upsertMultiple from "./upsert-multiple.js";

export default {
	createMultiple,
	deleteMultiple,
	upsertMultiple,
};
